'use client'

import React from 'react'
import Image from 'next/image'

const IndustriesSection = () => {
  const industries = [
    {
      name: "Product",
      image: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/bsi1.png"
    },
    {
      name: "Tech", 
      image: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/bsi2.png"
    },
    {
      name: "Design",
      image: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/bsi3.png"
    },
    {
      name: "Marketing",
      image: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/bsi4.png"
    },
    {
      name: "Business",
      image: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/bsi5.png"
    },
    {
      name: "Data",
      image: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/bsi6.png"
    }
  ]

  return (
    <div className="w-full py-10 md:py-20 bg-[#fcf8ef]">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 md:mb-12">
          <p className="text-sm md:text-base uppercase font-medium tracking-wide text-gray-600 mb-4">
            COMPREHENSIVE SKILLS DEVELOPMENT
          </p>
          <h2 className="text-3xl md:text-[36px] font-medium mb-8">
            Learn across Industries
          </h2>
        </div>

        {/* Desktop - Single Row */}
        <div className="hidden md:flex gap-6 justify-between">
          {industries.map((industry, index) => (
            <div key={index} className="flex-shrink-0">
              <Image
                src={industry.image}
                alt={industry.name}
                width={164}
                height={164}
                className="object-contain"
              />
            </div>
          ))}
        </div>

        {/* Mobile - Grid Layout */}
        <div className="md:hidden">
          <div className="grid grid-cols-2 gap-4">
            {industries.map((industry, index) => (
              <div key={index} className="flex justify-center">
                <Image
                  src={industry.image}
                  alt={industry.name}
                  width={164}
                  height={164}
                  className="object-contain w-full max-w-[164px]"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default IndustriesSection